import React from "react";
import { Container, Paper, Typography, Box, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { nomeEmpresa } from "../../../../package.json";

const useStyles = makeStyles((theme) => ({
    root: {
        height: "100vh",
        backgroundColor: theme.palette.type === "light" ? theme.palette.primary.main : "#1c1c1c",
        overflowY: "auto",
        overflowX: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),

        // Scrollbar vertical pill style with transparency
        "&::-webkit-scrollbar": {
            width: 8,
        },
        "&::-webkit-scrollbar-thumb": {
            background: "rgba(255, 255, 255, 0.35)",
            borderRadius: 100,
        },
        "&::-webkit-scrollbar-thumb:hover": {
            background: "rgba(255, 255, 255, 0.55)",
        },
        "&::-webkit-scrollbar-track": {
            background: "transparent",
        },
    },
    paper: {
        padding: theme.spacing(5),
        borderRadius: theme.neoUI?.floating.card?.borderRadius || 20,
        boxShadow: theme.neoUI?.floating.card?.boxShadow || "0 20px 60px -10px rgba(0, 0, 0, 0.15), 0 8px 24px -4px rgba(0, 0, 0, 0.1)",
        border: theme.neoUI?.floating.card?.border || "1px solid rgba(0, 0, 0, 0.04)",
        backgroundColor: "#ffffff",
        color: "#000000",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: theme.neoUI?.floating.card?.hoverShadow || "0 28px 70px -10px rgba(0, 0, 0, 0.18), 0 12px 30px -4px rgba(0, 0, 0, 0.12)",
        },
    },
    button: {
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        borderRadius: 10,
        padding: "10px 20px",
        fontWeight: 600,
        boxShadow: theme.neoUI?.floating.button?.boxShadow || "0 4px 12px rgba(20, 164, 92, 0.25)",
        transition: "all 0.3s ease-in-out",
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            transform: "translateY(-2px)",
            boxShadow: theme.neoUI?.floating.button?.hoverShadow || "0 8px 20px rgba(20, 164, 92, 0.3)",
        },
    },
}));

const TermsOfService = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Container maxWidth="md">
                <Paper className={classes.paper}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Typography variant="h4" component="h1" gutterBottom>
                            Termos de Serviço
                        </Typography>
                        <Button variant="contained" className={classes.button} component={Link} to="/login">
                            Voltar para Login
                        </Button>
                    </Box>

                    <Typography variant="body1" paragraph>
                        Última atualização: {new Date().toLocaleDateString()}
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        1. Aceitação dos Termos
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Ao acessar e usar a plataforma {nomeEmpresa}, você concorda em cumprir e estar vinculado aos seguintes termos e condições de uso. Se você não concordar com estes termos, não deverá utilizar nossos serviços.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        2. Descrição do Serviço
                    </Typography>
                    <Typography variant="body1" paragraph>
                        O {nomeEmpresa} é uma plataforma de gestão de atendimento e automação para WhatsApp (SaaS). Nossos serviços são fornecidos "como estão" e podem ser modificados, suspensos ou descontinuados a qualquer momento, com ou sem aviso prévio.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        3. Responsabilidades do Usuário
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Você é responsável por todas as atividades que ocorrem em sua conta. Você concorda em não usar o serviço para fins ilegais ou não autorizados, incluindo, mas não se limitando a, violação de direitos autorais, envio de spam ou distribuição de malware. O uso da API do WhatsApp deve estar em conformidade com as políticas da Meta.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        4. Privacidade e Proteção de Dados
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Sua privacidade é importante para nós. Nossa Política de Privacidade explica como coletamos, usamos e protegemos suas informações pessoais. Ao usar nossos serviços, você concorda com a coleta e uso de dados de acordo com nossa política.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        5. Pagamento e Assinatura
                    </Typography>
                    <Typography variant="body1" paragraph>
                        O acesso a certos recursos do serviço pode exigir o pagamento de taxas. As taxas são cobradas antecipadamente e não são reembolsáveis, exceto conforme exigido por lei. Reservamo-nos o direito de alterar nossos preços a qualquer momento, mediante aviso prévio.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        6. Cancelamento e Rescisão
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Você pode cancelar sua conta a qualquer momento. Reservamo-nos o direito de suspender ou encerrar sua conta se você violar estes Termos de Serviço ou se o uso do serviço prejudicar nossa plataforma ou outros usuários.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        7. Propriedade Intelectual
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Todos os direitos, títulos e interesses relativos ao serviço, incluindo todo o conteúdo, design, software e marcas registradas, são de propriedade exclusiva do {nomeEmpresa} ou de seus licenciadores.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        8. Limitação de Responsabilidade
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Em nenhuma circunstância o {nomeEmpresa} será responsável por quaisquer danos diretos, indiretos, incidentais, especiais ou consequentes decorrentes do uso ou da incapacidade de usar o serviço.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        9. Alterações nos Termos
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Podemos atualizar estes Termos de Serviço periodicamente. Notificaremos você sobre quaisquer alterações significativas enviando um e-mail ou publicando um aviso em nosso site.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        10. Contato
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Se você tiver alguma dúvida sobre estes Termos de Serviço, entre em contato conosco através de nossos canais de suporte.
                    </Typography>
                </Paper>
            </Container>
        </div>
    );
};

export default TermsOfService;
